import { alpha } from '@mui/material/styles';

const BG_KINDS = new Set(['default', 'tint', 'solid', 'image']);

/**
 * Normalize Firestore `companies/{id}` fields for the signed-in member dashboard.
 * @param {Record<string, unknown>} d
 */
export function mapCompanyPortalData(d) {
  if (!d || typeof d !== 'object') return null;
  const kind = typeof d.portalBackgroundKind === 'string' && BG_KINDS.has(d.portalBackgroundKind)
    ? d.portalBackgroundKind
    : 'default';
  return {
    name: typeof d.name === 'string' ? d.name : '',
    logoUrl: typeof d.logoUrl === 'string' ? d.logoUrl : '',
    brandColor: typeof d.brandColor === 'string' && d.brandColor ? d.brandColor : '#D85A30',
    portalBrandingEnabled: Boolean(d.portalBrandingEnabled),
    portalBackgroundKind: kind,
    portalBackgroundSolidColor:
      typeof d.portalBackgroundSolidColor === 'string' && d.portalBackgroundSolidColor
        ? d.portalBackgroundSolidColor
        : typeof d.brandColor === 'string' && d.brandColor
          ? d.brandColor
          : '#1976d2',
    portalBackgroundImageUrl:
      typeof d.portalBackgroundImageUrl === 'string' ? d.portalBackgroundImageUrl : '',
  };
}

/**
 * @typedef {object} CompanyPortalBranding
 * @property {boolean} portalBrandingEnabled
 * @property {string} [logoUrl]
 * @property {string} [name]
 * @property {string} [brandColor]
 * @property {'default'|'tint'|'solid'|'image'} [portalBackgroundKind]
 * @property {string} [portalBackgroundSolidColor]
 * @property {string} [portalBackgroundImageUrl]
 */

/**
 * Sx for the dashboard outer shell (behind drawer + main) when portal branding is on.
 * @param {import('@mui/material/styles').Theme} theme
 * @param {CompanyPortalBranding | null} portal
 */
export function workspaceShellBackgroundSx(theme, portal) {
  if (!portal?.portalBrandingEnabled) return {};
  const brand = portal.brandColor || theme.palette.primary.main;
  const kind = portal.portalBackgroundKind || 'default';
  const solid = portal.portalBackgroundSolidColor || brand;
  const img = portal.portalBackgroundImageUrl;

  switch (kind) {
    case 'tint':
      return {
        background: `linear-gradient(180deg, ${alpha(brand, theme.palette.mode === 'dark' ? 0.22 : 0.14)} 0%, ${theme.palette.background.default} 42%, ${theme.palette.background.default} 100%)`,
      };
    case 'solid':
      return { bgcolor: solid };
    case 'image':
      if (!img) return {};
      return {
        backgroundImage: `linear-gradient(${alpha(theme.palette.background.default, theme.palette.mode === 'dark' ? 0.82 : 0.9)}, ${alpha(theme.palette.background.default, theme.palette.mode === 'dark' ? 0.92 : 0.96)}), url('${String(img).replace(/'/g, '%27')}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: { xs: 'scroll', md: 'fixed' },
      };
    default:
      return {};
  }
}
